import React, {useEffect, useState} from "react";

import 'react-calendar/dist/Calendar.css';
import Calendar from 'react-calendar';
import "./modalCalendar.scss";
import moment from "moment";
import "moment/locale/es";

const ModalCalendar = ({handleOpenCalendar,handleShowRegisterForm,handleDateMobile,valueDateMobile, handleCleanDateMobile}) => {

    const [legalAge,setLegalAge] = useState(null);

    const handleCancelSelectDate = () => {
        handleCleanDateMobile("");
        handleShowRegisterForm(true);
        handleOpenCalendar(false);
    }

    const handleSelectDate = (date) => {
        const parsedDate = moment(date).format("DD/MM/YYYY");
        handleDateMobile(parsedDate);
    };

    const handleMinDate = () => {
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 18);
        setLegalAge(minDate);

    }

    useEffect(() => {
        handleMinDate();
    }, []);

    return (
        <div className={'modal-calendar'}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className="form-group">
                        <label htmlFor="Birthday"><i className="fas fa-calendar"></i> Fecha de nacimiento</label>
                        <input
                            disabled={true}
                            type="text"
                            id={"Birthday"}
                            className="form-control"
                            placeholder={`${"Dia"} / ${"Mes"} / ${"Año"}`}
                            value={valueDateMobile}
                        />
                    </div>
                </div>
                <div className={"col-12"}>
                    {(legalAge !== null) && (
                        <Calendar
                            onChange={handleSelectDate}
                            maxDate={legalAge}
                            defaultValue={legalAge}
                        />
                    )}

                </div>
                <div className={"col-12"}>
                    <div className={"modal-calendar__footer"}>
                        <button
                            type="button"
                            className={'btn btn-outline-dark'}
                            onClick={handleCancelSelectDate}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className={'btn'}
                            onClick={() => {
                                handleShowRegisterForm(true);
                                handleOpenCalendar(false);
                            }}
                        >
                            Seleccionar fecha
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ModalCalendar;
